<template>
    <div class="documentos" v-loading="loading">
       
        <ul v-if="documentos && documentos.length">
            <li 
            v-for="(doc,i) in documentos" 
            :key="i" 
            class="c-pointer" 
            @click="downloadFile(doc)">
                <i class="el-icon-tickets"></i>
                <div>
                    <p>{{doc.__fileorigin}}</p>
                    <span>{{doc.__filedate}}</span>
                </div>
                <i class="el-icon-arrow-right"></i>
            </li>
        </ul>
       
        <!--<el-alert v-else
            :closable="false"
            title="No hay documentos"
            type="info">
        </el-alert>-->
        <div v-else class="empty">
            <img src="../../assets/NoDocuments.png">
            <p>No hay documentos</p>
        </div>

        <!-- Visor de documentos -->
        <el-dialog
            title="Previsualizar"
            :visible.sync="visor"
            width="500px">

            <Preview></Preview>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="visor = false">Cerrar</el-button>
                <el-button type="primary">Actualizar</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import Preview from '@/components/Preview.vue'
    import {
        getDocumentos,
        getUrl
    } from '@/helpers/api'
    
	export default {
        name: 'Documentos',
        props: {
            visible: {
                type: Boolean,
                default: () => false
            }
        },
        components: {
            Preview
        },
        data(){
            return {
                error: null,
                loading: false,
                documentos: [],
                visor: false
            }
        },
        watch: {
            visible() {
                if (!this.visible) return
                this.getData()
            }
        },
        mounted() {
            if (this.visible) {
                this.getData()
            }
            this.$emit('created')
        },
        methods: {
            async getData(force = false) {
                
                if (this.documentos && this.documentos.length && !force) return

                this.loading = true

                let resp = null
                try {

                    resp = await getDocumentos()
                    if (resp && resp.status == 200 && resp.data) {
                        this.documentos = resp.data.documentos
                    } else {
                        this.error = e
                    }

                } catch(e) {
                    this.error = e
                }

                this.loading = false
            },
            previsualizar(doc) {

            },
            downloadFile(doc) {
                var left = (screen.width - 600) / 2;
                var top = (screen.height - 700) / 4;
                this.openwindow(`${getUrl().backendDownload}/download?link=${doc.urlDescarga}`)
            },
            refresh() {
                this.getData(true)
            }
        }
	}
</script>

<style lang="scss">
.documentos {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 5px;
    .upload {
        text-align: center;
        border-radius: 4px;
        border: 2px dashed #4a596a4d;
        padding: 10px;
        margin-bottom: 10px;
        cursor: pointer;
        font-size: 1.5rem;
        color: #4a596a;
        background-color: #4a596a0d;
        &:hover {
            border-color:#4a596a;
        }
    }
    ul {
        list-style: none;
        list-style: none;
        padding: 0px;
        margin: 0px;
        li {
            border: 1px solid #e4e7ed;
            margin-bottom: 5px;
            padding: 10px;
            display: flex;
            flex-direction: row;
            border-radius: 5px;
            align-items: center;

            i:first-child {
                font-size: 2rem;
                color:#4a596a;
            }

            > div {
                display: flex;
                flex-flow: column;
                flex-grow: 1;
                margin-left: 8px;
                p {
                    margin: 0px 0px 5px 0px;
                    font-size: 0.8rem;
                    font-weight: 600;
                    display: flex;
                    align-items: baseline;
                    i {
                        margin-right: 5px;
                    }
                }
                span {
                    font-size: 0.8rem;
                    display: block;
                }
                &:hover {
                    p {
                        color: #d63031;
                    }
                }
            }
            
        }
    }
}
</style>